import { MerchandiseShippingOrderCreationItem } from 'api/order'
import getMerchandiseShippingItemViews from 'checkout/selectors/view/itemViews/getMerchandiseShippingItemViews'
import { nonNullable } from 'lib/array/arrayUtils'
import { createSelector } from 'reselect'

const getFormattedMerchandiseShippingItems = createSelector(
  (state: App.State) => getMerchandiseShippingItemViews(state),
  (state: App.State) => state.checkout.form.deliveryForm,
  (views, form): Array<MerchandiseShippingOrderCreationItem> => {
    const items = views.data.map((view): MerchandiseShippingOrderCreationItem | undefined => {
      // Validate required fields
      if (!form.phoneNumber ||
        !form.firstName ||
        !form.lastName ||
        !form.address ||
        !form.city ||
        !form.state ||
        !form.postcode
      ) {
        return undefined
      }

      return {
        type: 'merchandise_shipping',
        transaction_key: view.item.transactionKey,
        total: view.totals.otherFees?.deliveryFee ?? 0,
        shippingGst: view.totals.otherFees?.deliveryGst,
        shippingGroup: view.item.itemId,
        address: {
          firstName: form.firstName,
          lastName: form.lastName,
          company: form.company,
          country: form.country ?? 'Australia',
          phone: `+${form.phoneNumber.prefix}${form.phoneNumber.phone}`,
          address: form.address,
          address2: form.unitNumber ?? undefined,
          city: form.city,
          state: form.state,
          postcode: form.postcode,
        },
      }
    })

    return nonNullable(items)
  }
)

export default getFormattedMerchandiseShippingItems
